import { useMutation } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const createOKRApi = ({ okrDetails }) => {
  const url = endpoints.rabbitGoals.createOKR;
  return sendRequest({
    method: 'POST',
    url,
    body: okrDetails,
    credentials: 'include',
  });
};

export const createOKRFromReviewsActionPlanApi = ({ okrDetails, reviewCycleId, actionPlanId }) => {
  const url = endpoints.reviews.reviewActionPlan.goals.create({ reviewCycleId, actionPlanId });
  return sendRequest({
    method: 'POST',
    url,
    body: okrDetails,
    credentials: 'include',
  });
};

export const useCreateNewOKRMutation = () =>
  useMutation({
    mutationFn: async ({ okrDetails, okrPanelPayload }) => {
      const modifiedOKRDetails = {
        ...okrDetails,
        taskType: okrDetails?.parentPost?.uuid ? 'SUB_OKR_TAG' : 'OKR_TAG',
      };

      if (okrPanelPayload?.from === 'REVIEW_ACTION_PLAN') {
        return createOKRFromReviewsActionPlanApi({
          okrDetails: modifiedOKRDetails,
          reviewCycleId: okrPanelPayload.reviewCycleId,
          actionPlanId: okrPanelPayload.actionPlanId,
        });
      }

      return createOKRApi({
        okrDetails: modifiedOKRDetails,
      });
    },
  });
